module.exports = __webpack_public_path__ + "static/media/Phone01.5728bfe5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Phone01.svg
// module id = 329
// module chunks = 0